import { render, staticRenderFns } from "./Cause.vue?vue&type=template&id=0d1cf64f"
import script from "./Cause.vue?vue&type=script&lang=js"
export * from "./Cause.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports